export default "__VITE_ASSET__4fa2ae3a__"